// Config i18n
export const availableLangs = ['es', 'ca'];
export const defaultLanguage = 'ca';
export const languageOptions = [
    { name: 'Català', value: 'ca' },
    { name: 'Castellano', value: 'es' },
];
